import React from 'react';
interface ArticleCardProps {
  title: string;
  category: string;
  date: string;
  author: string;
  imageUrl: string;
  imageClassName?: string;
}
export function ArticleCard({
  title,
  category,
  date,
  author,
  imageUrl,
  imageClassName = 'w-32 h-24'
}: ArticleCardProps) {
  return <div className="flex gap-4 group cursor-pointer" data-id="element-20">
      <img src={imageUrl} alt={title} className={`${imageClassName} object-cover flex-shrink-0`} data-id="element-21" />
      <div className="flex flex-col justify-start" data-id="element-22">
        <h3 className="font-serif text-[1.1rem] leading-tight text-gray-900 group-hover:text-[#002f5f] transition-colors" data-id="element-23">
          {title}
        </h3>
        <div className="text-xs mt-2" data-id="element-24">
          <span className="text-[#002f5f] hover:underline" data-id="element-25">{category}</span>
          <div className="text-gray-500 mt-1" data-id="element-26">
            {date}{' '}
            <span className="ml-2" data-id="element-27">
              By{' '}
              <span className="text-[#002f5f] hover:underline" data-id="element-28">{author}</span>
            </span>
          </div>
        </div>
      </div>
    </div>;
}